import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  MtAnimalBreederGetAnimalQuery,
  MtAnimalBreederGetAnimalQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const MT_ANIMAL_BREEDER_GET_ANIMAL = graphql(`
  query MtAnimalBreederGetAnimal($animalsWhere: AnimalWhereInput, $animalsTake: Int) {
    accountMe {
      id
      animals(where: $animalsWhere, take: $animalsTake) {
        id
        type
        name
        birthday
        birthdayType
        gender
        archived
        passportFile
        size
        sensitivities
        weight

        imgs {
          id
          medium
        }

        dogInfos {
          id
          pedigree
          breederIsDogOwner
          pedigreeNumber
          competitionTitles
          healthTestsResults
          microshipNumber
          color
          coat

          dogBreed {
            id
            name
          }
        }

        studInfos {
          id
          availableForBreeding
          price
          champion
          type
          adn
          accomodation
          description
        }
      }
    }
  }
`);

export const useGetAnimal = (id?: number) => {
  const variables = useMemo((): MtAnimalBreederGetAnimalQueryVariables => {
    return {
      animalsWhere: { id: { equals: id ?? -1 } },
      animalsTake: 1,
    };
  }, [id]);

  const { data, error, loading } = useQuery<
    MtAnimalBreederGetAnimalQuery,
    MtAnimalBreederGetAnimalQueryVariables
  >(MT_ANIMAL_BREEDER_GET_ANIMAL, { variables, skip: id == null });

  return {
    animal: data?.accountMe?.animals?.[0],
    animalError: error,
    animalLoading: loading,
    animalVariables: variables,
  };
};
